import XPagination from './XPagination'

export default XPagination
export { XPagination }
